var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _path9, _g2, _path0, _g3, _path1, _path10, _g4, _path11, _path12, _path13, _g5, _path14, _path15, _path16, _path17, _path18, _g6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPikkoLogoWelcome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 303,
    viewBox: "0 0 176 303",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.6875 138.332L75.5195 138.311C50.9394 138.147 31.8216 130.974 18.6924 116.955C-1.86228 95.0234 -0.00862472 64.5471 0.0791222 63.2628L0.320426 59.7253L3.90708 59.475C3.90708 59.475 4.91617 59.3988 6.69304 59.3988C18.8021 59.3988 79.2049 63.0124 79.6655 134.196L79.6875 138.332Z",
    fill: "url(#paint0_linear_9373_26936)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6806 108.319L83.841 105.469C67.0902 88.6675 58.9541 70.7575 59.6561 52.2352C60.7515 23.2329 83.1072 3.60253 84.0643 2.78987L86.6806 0.520767L89.3076 2.78987C90.2648 3.60253 112.62 23.2329 113.716 52.2352C114.418 70.7575 106.282 88.6675 89.5309 105.469L86.6806 108.319Z",
    fill: "url(#paint1_linear_9373_26936)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4194 138.332L96.4517 134.279C96.9031 64.5201 156.097 60.9788 167.953 60.9788C169.705 60.9788 170.694 61.0535 170.694 61.0535L174.198 61.2988L174.445 64.7654C174.531 66.024 176.348 95.8796 156.204 117.383C143.349 131.122 124.603 138.151 100.504 138.311L96.4194 138.332Z",
    fill: "url(#paint2_linear_9373_26936)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M118.167 302.814V108.472C117.589 108.433 117.022 108.433 116.445 108.433H58.8409V302.814H118.167ZM44.0779 302.814H58.8409V108.472H58.518C34.6468 108.472 13.6911 127.801 11.9692 151.402L3.89801 259.932C2.12724 283.484 20.2165 302.814 44.0779 302.814ZM130.875 302.814C154.746 302.814 172.826 283.484 171.065 259.883L162.984 151.363C161.262 128.335 141.255 109.375 118.128 108.472V302.814H130.875Z",
    fill: "#FFDE59"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9373_26936",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 98,
    y: 102,
    width: 78,
    height: 76
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8262 102.07H175.077V177.737H98.8262V102.07Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9373_26936)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9373_26936",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 98,
    y: 102,
    width: 78,
    height: 76
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M136.96 102.087C115.897 102.087 98.8347 119.018 98.8347 139.92C98.8347 160.813 115.897 177.754 136.96 177.754C158.014 177.754 175.086 160.813 175.086 139.92C175.086 119.018 158.014 102.087 136.96 102.087Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9373_26936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.8347 102.087H175.086V177.754H98.8347V102.087Z",
    fill: "white"
  })))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M164.224 166.014C142.845 179.398 111.638 168.588 105.604 161.724C113.362 172.878 116.379 173.307 126.724 177.168C137.5 180.599 143.029 185.318 146.983 185.318C151.724 185.318 148.737 177.818 150.862 177.168C156.466 175.452 157.759 185.318 164.224 185.318C171.121 185.318 166.81 169.875 165.948 167.73C165.259 166.014 164.655 165.585 164.224 166.014Z",
    fill: "#ECECFC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M132.034 108.848C118.895 108.848 108.251 119.411 108.251 132.449C108.251 145.478 118.895 156.04 132.034 156.04C145.163 156.04 155.807 145.478 155.807 132.449C155.807 119.411 145.163 108.848 132.034 108.848Z",
    fill: "#3D1F1E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_9373_26936",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 53,
    y: 183,
    width: 70,
    height: 80
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7402 183.946H122.977V262.098H53.7402V183.946Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_9373_26936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.3525 282.567C86.0798 282.567 83.8322 282.255 81.6097 281.618C79.3746 280.994 77.2149 280.057 75.118 278.821C73.0211 277.572 71.0246 276.061 69.1411 274.262C67.2451 272.464 65.4997 270.416 63.8925 268.13C62.2853 265.833 60.8538 263.347 59.5982 260.65C58.33 257.965 57.2627 255.117 56.3963 252.12C55.5299 249.135 54.8769 246.051 54.4249 242.879C53.9854 239.694 53.772 236.497 53.772 233.25C53.772 230.016 53.9854 226.806 54.4249 223.634C54.8769 220.462 55.5299 217.377 56.3963 214.38C57.2627 211.395 58.33 208.548 59.5982 205.863C60.8538 203.165 62.2853 200.68 63.8925 198.382C65.4997 196.097 67.2451 194.049 69.1411 192.25C71.0246 190.452 73.0211 188.941 75.118 187.692C77.2149 186.456 79.3746 185.519 81.6097 184.895C83.8322 184.258 86.0798 183.946 88.3525 183.946C90.6253 183.946 92.8729 184.258 95.0954 184.895C97.3304 185.519 99.4901 186.456 101.587 187.692C103.684 188.941 105.68 190.452 107.564 192.25C109.46 194.049 111.205 196.097 112.813 198.382C114.42 200.68 115.851 203.165 117.107 205.863C118.375 208.548 119.442 211.395 120.309 214.38C121.175 217.377 121.828 220.462 122.28 223.634C122.72 226.806 122.933 230.016 122.933 233.25C122.933 236.497 122.72 239.694 122.28 242.879C121.828 246.051 121.175 249.135 120.309 252.12C119.442 255.117 118.375 257.965 117.107 260.65C115.851 263.347 114.42 265.833 112.813 268.13C111.205 270.416 109.46 272.464 107.564 274.262C105.68 276.061 103.684 277.572 101.587 278.821C99.4901 280.057 97.3304 280.994 95.0954 281.618C92.8729 282.255 90.6253 282.567 88.3525 282.567Z",
    fill: "#3D1F1E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_9373_26936",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 59,
    y: 233,
    width: 60,
    height: 44
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0713 233.364H118.941V276.162H59.0713V233.364Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_9373_26936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.941 254.756C118.941 256.155 118.74 257.541 118.363 258.928C117.974 260.301 117.409 261.638 116.655 262.936C115.902 264.235 114.985 265.459 113.893 266.633C112.8 267.794 111.557 268.881 110.164 269.868C108.782 270.867 107.263 271.753 105.631 272.528C103.998 273.314 102.278 273.964 100.457 274.501C98.6368 275.038 96.7659 275.45 94.8447 275.725C92.911 275.999 90.9648 276.137 89.0059 276.137C87.0346 276.137 85.0883 275.999 83.1672 275.725C81.2335 275.45 79.3626 275.038 77.5419 274.501C75.7337 273.964 74.0009 273.314 72.3686 272.528C70.7363 271.753 69.2169 270.867 67.8357 269.868C66.4419 268.881 65.1989 267.794 64.1064 266.633C63.014 265.459 62.0974 264.235 61.344 262.936C60.5906 261.638 60.0256 260.301 59.6363 258.928C59.2596 257.541 59.0713 256.155 59.0713 254.756C59.0713 253.345 59.2596 251.959 59.6363 250.573C60.0256 249.199 60.5906 247.863 61.344 246.564C62.0974 245.265 63.014 244.041 64.1064 242.867C65.1989 241.706 66.4419 240.62 67.8357 239.633C69.2169 238.634 70.7363 237.747 72.3686 236.973C74.0009 236.186 75.7337 235.537 77.5419 235C79.3626 234.463 81.2335 234.051 83.1672 233.776C85.0883 233.501 87.0346 233.364 89.0059 233.364C90.9648 233.364 92.911 233.501 94.8447 233.776C96.7659 234.051 98.6368 234.463 100.457 235C102.278 235.537 103.998 236.186 105.631 236.973C107.263 237.747 108.782 238.634 110.164 239.633C111.557 240.62 112.8 241.706 113.893 242.867C114.985 244.041 115.902 245.265 116.655 246.564C117.409 247.863 117.974 249.199 118.363 250.573C118.74 251.959 118.941 253.345 118.941 254.756Z",
    fill: "#FA5B5B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_9373_26936",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 102,
    width: 77,
    height: 77
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M0 102.59H76.2508V178.257H0V102.59Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_9373_26936)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_9373_26936",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 102,
    width: 77,
    height: 77
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1254 102.607C17.0718 102.607 0 119.539 0 140.441C0 161.333 17.0718 178.274 38.1254 178.274C59.179 178.274 76.2508 161.333 76.2508 140.441C76.2508 119.539 59.179 102.607 38.1254 102.607Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_9373_26936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 102.607H76.2508V178.274H0V102.607Z",
    fill: "white"
  })))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4828 165.585C30.8621 178.969 53.8794 172.878 69.9146 162.153C62.9311 170.733 57.6717 174.594 46.1207 178.884C35.2579 182.315 34.5577 184.031 30.6035 184.031C25.8621 184.031 26.7815 178.248 24.6559 177.597C19.0525 175.881 17.7594 183.602 11.2939 183.602C3.4875 183.602 5.60349 170.733 6.46556 168.588C7.15522 166.872 9.05177 165.156 9.4828 165.585Z",
    fill: "#ECECFC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_9373_26936",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 109,
    width: 48,
    height: 48
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0869 109.239H67.6336V156.431H20.0869V109.239Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_9373_26936)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_9373_26936",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 109,
    width: 48,
    height: 48
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8686 109.239C30.7394 109.239 20.0952 119.801 20.0952 132.84C20.0952 145.868 30.7394 156.431 43.8686 156.431C56.9977 156.431 67.6419 145.868 67.6419 132.84C67.6419 119.801 56.9977 109.239 43.8686 109.239Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_9373_26936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0952 109.239H67.6419V156.431H20.0952V109.239Z",
    fill: "#3D1F1E"
  })))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M49.138 132.983C49.138 127.003 53.6121 122.692 59.4829 122.692C53.885 122.692 49.1428 118.1 49.1428 112.397C49.1428 118.046 44.7172 122.692 38.7932 122.692C44.7172 122.692 49.138 127.22 49.138 132.983Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M49.138 112.392L49.1428 112.397M49.1428 112.397C49.1428 118.1 53.885 122.692 59.4829 122.692C53.6121 122.692 49.138 127.003 49.138 132.983C49.138 127.22 44.7172 122.692 38.7932 122.692C44.7172 122.692 49.1428 118.046 49.1428 112.397Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M125 132.983C125 127.003 129.474 122.692 135.345 122.692C129.747 122.692 125.005 118.1 125.005 112.397C125.005 118.046 120.579 122.692 114.655 122.692C120.579 122.692 125 127.22 125 132.983Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M125 112.392L125.005 112.397M125.005 112.397C125.005 118.1 129.747 122.692 135.345 122.692C129.474 122.692 125 127.003 125 132.983C125 127.22 120.579 122.692 114.655 122.692C120.579 122.692 125.005 118.046 125.005 112.397Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.01
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_9373_26936",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 86,
    y: 243,
    width: 6,
    height: 2
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M86.791 243.889H91.3351V244.46H86.791V243.889Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_9373_26936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.3351 244.174C91.3351 244.193 91.3198 244.211 91.2912 244.23C91.2617 244.248 91.2188 244.266 91.1616 244.283C91.1044 244.301 91.0349 244.317 90.952 244.333C90.869 244.348 90.7747 244.363 90.6689 244.376C90.5641 244.389 90.4488 244.401 90.3249 244.411C90.201 244.422 90.0704 244.43 89.9322 244.438C89.794 244.445 89.652 244.45 89.5062 244.454C89.3594 244.457 89.2117 244.459 89.063 244.459C88.9134 244.459 88.7657 244.457 88.6199 244.454C88.4731 244.45 88.3311 244.445 88.1929 244.438C88.0557 244.43 87.9242 244.422 87.8003 244.411C87.6764 244.401 87.5611 244.389 87.4562 244.376C87.3504 244.363 87.2561 244.348 87.1732 244.333C87.0903 244.317 87.0207 244.301 86.9635 244.283C86.9063 244.266 86.8634 244.248 86.8339 244.23C86.8053 244.211 86.791 244.193 86.791 244.174C86.791 244.156 86.8053 244.137 86.8339 244.119C86.8634 244.1 86.9063 244.082 86.9635 244.065C87.0207 244.048 87.0903 244.032 87.1732 244.016C87.2561 244 87.3504 243.986 87.4562 243.973C87.5611 243.959 87.6764 243.948 87.8003 243.937C87.9242 243.927 88.0557 243.918 88.1929 243.911C88.3311 243.904 88.4731 243.898 88.6199 243.895C88.7657 243.891 88.9134 243.889 89.063 243.889C89.2117 243.889 89.3594 243.891 89.5062 243.895C89.652 243.898 89.794 243.904 89.9322 243.911C90.0704 243.918 90.201 243.927 90.3249 243.937C90.4488 243.948 90.5641 243.959 90.6689 243.973C90.7747 243.986 90.869 244 90.952 244.016C91.0349 244.032 91.1044 244.048 91.1616 244.065C91.2188 244.082 91.2617 244.1 91.2912 244.119C91.3198 244.137 91.3351 244.156 91.3351 244.174Z",
    fill: "#FA5B5B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9373_26936",
    x1: 39.8437,
    y1: 59.3988,
    x2: 39.8437,
    y2: 138.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9373_26936",
    x1: 86.686,
    y1: 0.520767,
    x2: 86.686,
    y2: 108.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9373_26936",
    x1: 135.471,
    y1: 60.9788,
    x2: 135.471,
    y2: 138.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPikkoLogoWelcome);
export default __webpack_public_path__ + "static/media/pikkoLogoWelcome.c38810cae16b5307d8aebe57e2749752.svg";
export { ForwardRef as ReactComponent };